import { useDispatch, useSelector } from "react-redux";
import { Button, CircularProgress } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import { exportQbrReportApi } from "../../redux/slice/qbr-export";

/**
 * Downloads the QBR report document for the current view.
 *
 * `quarter` is the compact quarter id (e.g. `Q32026`) or undefined for the
 * live current quarter; `productGroup` is the product group the page shows.
 * `disabled` lets the parent gate the button until the report data is ready.
 * Loading and error state live in the `qbrExport` slice (one download at a
 * time); errors surface through the shared snackbar from the thunk.
 */
function ExportQbrButton({ quarter, productGroup, disabled = false }) {
  const dispatch = useDispatch();
  const isExporting = useSelector((state) => state.qbrExport.isLoading);

  const handleExport = () => {
    dispatch(exportQbrReportApi({ quarter, productGroup }));
  };

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleExport}
      disabled={disabled || isExporting}
      startIcon={
        isExporting ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <FileDownloadOutlinedIcon />
        )
      }
      sx={{ textTransform: "none" }}
    >
      {isExporting ? "Exporting…" : "Export"}
    </Button>
  );
}

export default ExportQbrButton;
